import { render, staticRenderFns } from "./Emitent.vue?vue&type=template&id=4e87dd1a&"
import script from "./Emitent.vue?vue&type=script&lang=js&"
export * from "./Emitent.vue?vue&type=script&lang=js&"
import style0 from "./Emitent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports